const generateKey = (pre: string, i?: number) => {
  return `${pre}_${i ? `${i}_` : ''}${new Date().getTime()}`;
};

export default generateKey;
